import React, { useEffect, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import {
  CheckCircleOutline,
  ContentCopy,
  RemoveCircleOutline,
  Preview,
} from "@mui/icons-material";

import {
  POLICY_STATUS_DELETED,
  POLICY_STATUS_EDIT,
} from "../Constants/PolicyTranslationConstants";
import DiagnosisCodeDialog from "components/shared/Dialogs/DiagnosisCodeDialog";

const green = "green";
const resetColor = "inherit";
const ActionsFragment = ({ handleDelete, editable, params }) => {
  const [openDxDialog, setOpenDxDialog] = useState(false);
  const [dxCodes, setDxCodes] = useState([]);

  const handleOpenDxDialog = (dxCodes) => {
    setDxCodes(dxCodes);
    setOpenDxDialog(true);
  };

  const handleSaveDxCodes = (codes) => {
    // Handle saving the dx codes
    console.log("Saved Dx Codes:", codes);
  };

  const setCheckColor = (color) => {
    const cellElement = params.api.getCellElement(params.id, "actions");
    if (cellElement) {
      const checkIcon = cellElement.querySelector(
        ".MuiSvgIcon-root.validateRowCheck"
      );
      if (checkIcon) {
        checkIcon.style.color = color;
      }
    }
  };

  useEffect(() => {
    if (params.row.errors && Object.keys(params.row.errors).length)
      setCheckColor(resetColor);
    else setCheckColor(green);
  }, [params.row?.errors, setCheckColor]);

  const handleValidateRow = () => {
    if (!params.row.errors || !Object.keys(params.row.errors).length)
      setCheckColor(green);
  };

  const showCheckIcon =
    params.row?.RuleHeader?.EditRule &&
    params.row?.RuleHeader?.EditRule !== POLICY_STATUS_EDIT;
  return (
    <>
      {(params.row.RuleHeader.EditRule ?? "").toUpperCase() !==
        POLICY_STATUS_DELETED && (
        <>
          {showCheckIcon && (
            <Tooltip title="Validate Row">
              <IconButton onClick={() => handleValidateRow()} aria-label="info">
                <CheckCircleOutline className="validateRowCheck" />
              </IconButton>
            </Tooltip>
          )}

          <IconButton aria-label="edit">
            <ContentCopy />
          </IconButton>
          {editable && (
            <IconButton
              aria-label="delete"
              onClick={() => handleDelete(params.row.index)}
            >
              <RemoveCircleOutline />
            </IconButton>
          )}
        </>
      )}
      <Tooltip title="View Diagnosis">
        <IconButton
          onClick={() =>
            handleOpenDxDialog({
              dxCodesExpanded: params.row.RuleFacts.DiagnosisListExpanded,
              dxCodesCondensed: params.row.RuleFacts.DiagnosisListCondensed,
            })
          }
        >
          <Preview />
        </IconButton>
      </Tooltip>
      <DiagnosisCodeDialog
        open={openDxDialog}
        dxCodes={dxCodes}
        onClose={() => setOpenDxDialog(false)}
        onSave={handleSaveDxCodes}
        readOnly
      />
    </>
  );
};

export default ActionsFragment;
